import { Link } from "react-router-dom";
import { latestArticles } from "@/mocks/articles";

export default function LatestArticlesGrid() {
  const articles = latestArticles.slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Title */}
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight">
                最新爆料
              </h2>
              <p className="text-foreground-500 text-base mt-3">
                第一时间获取娱乐圈最新动态
              </p>
            </div>
            <Link
              to="/category/star-gossip"
              className="inline-flex items-center gap-2 text-primary-500 font-medium text-sm hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Articles Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article) => (
              <article key={article.id} className="group">
                <Link to={`/article/${article.id}`} className="block">
                  <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all hover:shadow-lg">
                    {/* Image */}
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    {/* Content */}
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium">
                          {article.categoryName}
                        </span>
                        <span className="text-foreground-400 text-xs">
                          {article.publishDate}
                        </span>
                      </div>
                      <h3 className="font-heading font-bold text-foreground-950 text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
                        <span className="text-foreground-400 text-xs">
                          {article.author}
                        </span>
                        <div className="flex items-center gap-3 text-foreground-400 text-xs">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line" />
                            {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line" />
                            {article.commentCount}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}